<template>
    <basic-background-hero-section
        class="basic-background-hero-section-module"
        :title="attributes.basicBackgroundHero_title"
        :background-image="backgroundImage"
    />
</template>

<script>
    import BasicBackgroundHeroSection from '../../../organisms/BasicBackgroundHeroSection/BasicBackgroundHeroSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'basic-background-hero-section-module',

        components: { BasicBackgroundHeroSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Return a type safe background image.
             *
             * @returns {{src: (string|undefined|null), alt: (string|undefined|null)}}
             */
            backgroundImage() {
                return formatMediaObject.call(this, this.attributes.basicBackgroundHero_background_image);
            },
        },
    };
</script>
